window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.files = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.files", 'Forms Field (Files)');
    const _thisField = parent;
    const _shared = shared;
    const _browserSupportsFileApi = (window.File && window.FileReader && window.FileList && window.Blob) ? true : false;
    let _validatedControlWrapper = null;
    let _validationCanvas = null;
    let _controlWrapper = null;
    let _inputIndex = 0;
    const _controls = {};

    const render = function (fieldGroup) {
        _controlWrapper = document.createElement('ul');

        if (_browserSupportsFileApi) {
            _controlWrapper.classList.add(window.mcb.forms.constants.fields.filesClass);
            _controlWrapper.classList.add(window.mcb.forms.constants.fields.filelist);

            addInput();
        }

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(_controlWrapper);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const addInput = function () {
        _inputIndex++;
        const inputWrapper = document.createElement('li');
        inputWrapper.classList.add(window.mcb.forms.constants.fields.filewrapper);
        _controlWrapper.append(inputWrapper);

        const row = document.createElement('div');
        row.classList.add(window.mcb.forms.constants.fields.filerow);
        inputWrapper.append(row);

        const input = document.createElement('input');
        input.type = 'file';
        input.name = _thisField.alias;
        input.classList.add(window.mcb.forms.constants.fields.fileClass);
        input.accept = _thisField.settings.render.accept;
        input.addEventListener('blur', (event) => {
            _shared.fireFieldModifiedEvents(_controlWrapper, _thisField.applyValidationDuringInput, false);
        });

        row.append(input);

        const validateTarget = document.createElement('div');
        validateTarget.classList.add(window.mcb.forms.constants.validation.validationTarget);
        inputWrapper.append(validateTarget);

        const instance = "fr" + _inputIndex;
        _controls[instance] = new window.mcb.forms.fileReader(
            instance,
            _thisField,
            _shared,
            inputWrapper,
            row,
            input,
            validateTarget);
    }

    const handleFileUpdate = function () {
        _logger.log('controls when running Handle Update', JSON.parse(JSON.stringify(_controls)));
        let add = false;
        const controlsCount = Object.keys(_controls).length;
        const allSlotsFilled = controlsCount >= _thisField.validation.maxCount;
        if (allSlotsFilled === false) {
            const addBecauseEmpty = controlsCount === 0;
            if (addBecauseEmpty) {
                add = true;
            }
            else {
                let hasEmptyOrInvalid = false;
                for (const instance in _controls) {
                    const value = _controls[instance].getValue(false);
                    if (value.isEmpty === true || value.isValid === false) {
                        hasEmptyOrInvalid = true;
                        break;
                    }
                }

                add = !hasEmptyOrInvalid;
            }
        }

        if (add === true) {
            addInput();
        }

        _shared.fireFieldModifiedEvents(_controlWrapper, _thisField.applyValidationDuringInput, false);
    };

    const handleFileRemove = function (instance, fileReader, filewrapper, event) {
        _logger.log('controls when running Handle Update', JSON.parse(JSON.stringify(_controls)));
        if (typeof _controls[instance] === 'undefined') {
            throw new Error('FileReader not found in controls', fileReader);
        }

        _logger.trace('removed file from ' + _thisField.alias, event);
        filewrapper.remove();

        delete _controls[instance];

        _logger.log('controls when leaving Handle Update', JSON.parse(JSON.stringify(_controls)));
        handleFileUpdate();
    };

    const getValue = function (allowValueFormatting = false) {
        _logger.trace(_thisField.alias + ' (' + allowValueFormatting + '):: getValue called', _thisField, _controlWrapper);

        const values = [];
        const collectionValidation = new window.mcb.forms.validation.ValidationResult(true);
        if (_browserSupportsFileApi) {
            if (_validatedControlWrapper === null) {
                throw new Error("Control is not initialized");
            }

            if (_validatedControlWrapper.querySelector('input[type="file"]') === null) {
                throw new Error("Control has been removed from DOM");
            }

            if (_validatedControlWrapper.offsetParent === null) {
                _logger.trace('FileReader is not visible', _thisField.alias);
                // Field is not visible
                return undefined;
            }

            let hasInvalid = false;
            for (const instance in _controls) {
                const value = _controls[instance].getValue(allowValueFormatting);
                if (!value.isEmpty) {
                    if (value.isValid) {
                        values.push(value);
                    }
                    else {
                        _logger.trace('FileReader value is invalid', value);
                        hasInvalid = true;
                    }
                }
                else {
                    _logger.trace('FileReader value is empty', value);
                }
            }

            if (hasInvalid) {
                _logger.trace('Validation failed for one or more file inputs', _thisField.alias, values);
                return null;
            }

            if (values.length === 0 && _thisField.settings.required === true) {
                _logger.trace(_thisField.alias + ' is Violating Required Constraint');
                collectionValidation.aggregate(new window.mcb.forms.validation.ValidationResult(false, "NoValueViolation"));
            }
        }
        else {
            _logger.trace(_thisField.alias + ' is Not Supported in this Browser');
            collectionValidation.aggregate(new window.mcb.forms.validation.ValidationResult(false, "FileAPINotSupported"));
        }

        collectionValidation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (collectionValidation.isValid()) {
            _logger.trace(_thisField.alias + ' is returning Valid File Array', values);
            return values;
        }

        _logger.trace('Validation failed for collection', _thisField.alias, values);
        return null;
    };

    const setValue = function (value) {
        _logger.trace('setValue called on ' + _thisField.alias + ': ' + value);
        return false;
    }

    {
        // Init
        _thisField.settings.render = {
            accept: _thisField.settings.data.whitelist.reduce((acc, ext) => acc + '.' + ext + ', ', '').slice(0, -2),
        };

        _thisField.validation = JSON.parse(JSON.stringify(_thisField.settings.data));
        _thisField.validation.maxSize = window.mcb.forms.data.getMaxFileSize(_thisField.formId, _thisField.validation.limitSize);
        _thisField.validation.maxSizeFormatted = window.mcb.forms.helpers.renderFileSize(_thisField.validation.maxSize);
        _thisField.validation.whitelistFormatted = _thisField.validation.whitelist ?? null;
        _thisField.validation.whitelist = _thisField.validation.whitelist.map(ext => ext.toUpperCase().replaceAll('.', ''));

        _shared.handleFileUpdate = handleFileUpdate;
        _shared.handleFileRemove = handleFileRemove;
    }

    return _ = {
        render: render,
        postRender: function () {
            if (!_browserSupportsFileApi) {
                return getValue(false);
            }
        },
        getValue: getValue,
        setValue: setValue,
        handleFileUpdate: handleFileUpdate,
        handleFileRemove: handleFileRemove
    };
};
